import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  components: {
    DdButton: function DdButton() {
      return import('~/components/DdButton.vue');
    },
    PanelButton: function PanelButton() {
      return import('~/components/panels/PanelButton.vue');
    },
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    Collapse: function Collapse() {
      return import('~/components/collapse/Collapse.vue');
    },
    CollapseButton: function CollapseButton() {
      return import('~/components/collapse/Button.vue');
    },
    WebpPicture: function WebpPicture() {
      return import('~/components/WebpPicture.vue');
    }
  },
  computed: {
    authPanelStore: function authPanelStore() {
      return useAuthPanelStore();
    },
    companies: function companies() {
      var _this$$auth$user;
      if ((_this$$auth$user = this.$auth.user) !== null && _this$$auth$user !== void 0 && _this$$auth$user.moders) {
        return this.$auth.user.moders.filter(function (o) {
          return o.approved;
        }).map(function (o) {
          return o.company;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    login: function login() {
      this.authPanelStore.$patch({
        direction: 'right',
        state: 'login'
      });
    }
  }
};